import React from "react";
import { BsyUtils } from "../../utils/Utils";
import { BsyWidget } from "../BsyWidget";

import "./index.css";
import { dayjsUtils } from "../../utils/dayjsUtils";

export default class BsyDatePicker extends BsyWidget {
  trNum = [0, 1, 2, 3, 4, 5];
  trYearNum = [0, 1, 2, 3, 4];
  weekArray = [
    React.language("date.monday.short"),
    React.language("date.tuesday.short"),
    React.language("date.wednesday.short"),
    React.language("date.thursday.short"),
    React.language("date.friday.short"),
    React.language("date.saturday.short"),
    React.language("date.sunday.short"),
  ];
  CONSTS = {
    MINYEAR: 1000,
    MAXYEAR: 2999,
    NAV: {
      prevm: 2,
      nextm: 3,
      title: 4,
      clear: 5,
      today: 6,
      dok: 7,
      prevy: 8,
      nexty: 9,
      cancel: 10,
      mok: 11,
      plus: 12,
      minus: 13,
      current: 15,
      yok: 16,
      day: 100,
      month: 200,
      year: 300,
      year_only: 301,
      prevy_only: 302,
      nexty_only: 303,
    },
  };
  _TT = {
    CALENDAR: React.language("widget.datetime.calendar"),
    CLEAR: React.language("clear"),
    TODAY: React.language("today"),
    OK: React.language("ok"),
    CURRENT: React.language("current"),
    TIME: React.language("time"),
  };
  SDN = BsyUtils.getDateSDN();
  MN = BsyUtils.getDateMN();
  constructor(props) {
    let tdt = null;
    if (props.date) {
      tdt = new Date(props.date);
    } else {
      tdt = new Date();
    }

    super({
      baseCls: "bsy-datepicker",
      viewMode: 1,
      format: props.format ? props.format : "yyyy-MM-dd",
      customCls: props.customCls ? props.customCls : null,
      endDate: props.endDate ? props.endDate : null,
      startDate: props.startDate ? props.startDate : null,
      date: tdt,
      onDateUpdate: props.onDateUpdate ? props.onDateUpdate : null,
      onClear: props.onClear ? props.onClear : null,
      onOk: props.onOk ? props.onOk : null,
      onClose: props.onClose ? props.onClose : null,
      onToday: props.onToday ? props.onToday : null,
      hasTfoot: true,
      ...props,
    });
    this.state = {
      ...this.state,
      year: tdt.getFullYear(),
      month: tdt.getMonth(),
      day: tdt.getDate(),
      hours: tdt.getHours(),
      minutes: tdt.getMinutes(),
      seconds: tdt.getSeconds(),
      showMonth: false,
      showYear: false,
      showHms: true,
      footType: "",
    };
    this.startDate = this.options.startDate
      ? this.options.startDate
      : new Date(this.CONSTS.MINYEAR, 0, 1, 0, 0, 0, 0);
    this.endDate = this.options.endDate
      ? this.options.endDate
      : new Date(this.CONSTS.MAXYEAR, 11, 31, 23, 59, 59, 999);
    this.mountRef = React.createRef();

    this.hoursHandleChange = this.hoursHandleChange.bind(this);
    this.minutesHandleChange = this.minutesHandleChange.bind(this);
    this.secondsHandleChange = this.secondsHandleChange.bind(this);
  }

  updateDate(date) {
    let tdt = new Date(date);
    this.setState(
      {
        year: tdt.getFullYear(),
        month: tdt.getMonth(),
        day: tdt.getDate(),
        hours: tdt.getHours(),
        minutes: tdt.getMinutes(),
        seconds: tdt.getSeconds(),
      },
      () => {
        this.renderScrollTo();
      }
    );
  }

  componentDidMount() {
    super.componentDidMount();
    this.renderScrollTo();
  }
  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const newState = {
      ...this.state,
      ...nextProps,
    };
    this.setState(newState);
  }

  yearReduce = () => {
    if (this.CONSTS.MINYEAR > this.state.year) {
      return;
    }
    this.setState(
      {
        year: this.state.year - 1,
      },
      () => {
        this.onDateUpdate(false);
      }
    );
  };

  yearAdd = () => {
    if (this.CONSTS.MAXYEAR < this.state.year) {
      return;
    }
    this.setState(
      {
        year: this.state.year + 1,
      },
      () => {
        this.onDateUpdate(false);
      }
    );
  };

  yearFReduce = () => {
    if (this.CONSTS.MINYEAR > this.state.year) {
      return;
    }
    // TODO 日期控件，年份少了10年
    this.setState(
      {
        year: this.state.year - 20,
      },
      () => {
        // this.onDateUpdate(false);
      }
    );
  };

  yearFAdd = () => {
    if (this.CONSTS.MAXYEAR < this.state.year) {
      return;
    }
    // TODO 日期控件，年份少了10年
    this.setState(
      {
        year: this.state.year + 20,
      },
      () => {
        // this.onDateUpdate(false);
      }
    );
  };

  selectYear = (year) => {
    let showYear = this.state.showYear;
    let showMonth = this.state.showMonth;
    this.setState(
      {
        year: year,
        month:
          this.state.showYear || this.state.showMonth ? this.state.month : 0,
        day: this.state.showYear || this.state.showMonth ? this.state.day : 1,
        hours:
          this.state.showYear || this.state.showMonth ? this.state.hours : 0,
        minutes:
          this.state.showYear || this.state.showMonth ? this.state.minutes : 0,
        seconds:
          this.state.showYear || this.state.showMonth ? this.state.seconds : 0,
        showYear: false,
        showHms:
          ["HH:mm:ss", "yyyy-MM-dd HH:mm:ss"].indexOf(this.options.format) > -1
            ? true
            : false,
      },
      () => {
        if (showYear || showMonth) {
          this.onDateUpdate(false);
        } else {
          this.onDateUpdate(true);
        }
      }
    );
  };

  monthReduce = () => {
    if (this.CONSTS.MINYEAR > this.state.year) {
      return;
    }
    let { year, month, day } = this.state;
    if (month === 0) {
      month = 11;
      year -= 1;
    } else {
      month--;
    }
    let newDay = day;
    switch (day) {
      case "31":
      case 31: {
        switch (month) {
          case 0:
          case 2:
          case 4:
          case 6:
          case 7:
          case 9:
          case 11:
          case "0":
          case "2":
          case "4":
          case "6":
          case "7":
          case "9":
          case "11":
            newDay = 31;
            break;
          case 1:
          case "1": {
            if (
              (year % 4 === 0 && year % 100 !== 0) ||
              (year % 100 === 0 && year % 400 === 0)
            ) {
              newDay = 29;
            } else {
              newDay = 28;
            }

            break;
          }
          default:
            newDay = 30;
            break;
        }
        break;
      }
      case "30":
      case 30:
        switch (month) {
          case 1:
          case "1": {
            if (
              (year % 4 === 0 && year % 100 !== 0) ||
              (year % 100 === 0 && year % 400 === 0)
            ) {
              newDay = 29;
            } else {
              newDay = 28;
            }
            break;
          }
          default: {
          }
        }
        break;
      case "29":
      case 29: {
        if (
          (year % 4 === 0 && year % 100 !== 0) ||
          (year % 100 === 0 && year % 400 === 0)
        ) {
          newDay = 29;
        } else {
          newDay = 28;
        }
        break;
      }
      default:
    }

    this.setState(
      {
        month: month,
        year: year,
        day: newDay,
      },
      () => {
        this.onDateUpdate(false);
      }
    );
  };

  monthAdd = () => {
    if (this.CONSTS.MAXYEAR < this.state.year) {
      return;
    }
    let { year, month, day } = this.state;
    if (month === 11) {
      month = 0;
      year += 1;
    } else {
      month++;
    }
    let newDay = day;
    switch (day) {
      case "31":
      case 31: {
        switch (month) {
          case 0:
          case 2:
          case 4:
          case 6:
          case 7:
          case 9:
          case 11:
          case "0":
          case "2":
          case "4":
          case "6":
          case "7":
          case "9":
          case "11":
            newDay = 31;
            break;
          case 1:
          case "1": {
            if (
              (year % 4 === 0 && year % 100 !== 0) ||
              (year % 100 === 0 && year % 400 === 0)
            ) {
              newDay = 29;
            } else {
              newDay = 28;
            }
            break;
          }
          default:
            newDay = 30;
            break;
        }
        break;
      }
      case "30":
      case 30:
        switch (month) {
          case 1:
          case "1": {
            if (
              (year % 4 === 0 && year % 100 !== 0) ||
              (year % 100 === 0 && year % 400 === 0)
            ) {
              newDay = 29;
            } else {
              newDay = 28;
            }
            break;
          }
          default: {
          }
        }
        break;
      case "29":
      case 29: {
        if (
          (year % 4 === 0 && year % 100 !== 0) ||
          (year % 100 === 0 && year % 400 === 0)
        ) {
          newDay = 29;
        } else {
          newDay = 28;
        }
        break;
      }
      default:
    }
    this.setState(
      {
        month: month,
        year: year,
        day: newDay,
      },
      () => {
        this.onDateUpdate(false);
      }
    );
  };

  mountOk = (m) => {
    if (m !== undefined) {
      if (this.options.format === "yyyy-MM") {
        this.setState(
          {
            month: m,
            day: 1,
            hours: 0,
            minutes: 0,
            seconds: 0,
            showMonth: false,
            showYear: false,
            showHms:
              ["HH:mm:ss", "yyyy-MM-dd HH:mm:ss"].indexOf(this.options.format) >
                -1
                ? true
                : false,
          },
          () => {
            this.onDateUpdate(true);
          }
        );
      } else {
        this.setState(
          {
            month: m,
            showMonth: false,
            showYear: false,
            showHms:
              ["HH:mm:ss", "yyyy-MM-dd HH:mm:ss"].indexOf(this.options.format) >
                -1
                ? true
                : false,
          },
          () => {
            this.onDateUpdate(false);
          }
        );
      }
    }
    // this.mountRef.current.style.display = 'none';
  };
  yearOk = (y) => {
    if (y !== undefined) {
      if (this.options.format === "yyyy-MM") {
        this.setState(
          {
            year: y,
            day: 1,
            hours: 0,
            minutes: 0,
            seconds: 0,
            showMonth: false,
            showYear: false,
            showHms: true,
          },
          () => {
            this.onDateUpdate(true);
          }
        );
      } else {
        this.setState(
          {
            year: y,
            showMonth: false,
            showYear: false,
            showHms: true,
          },
          () => {
            this.onDateUpdate(false);
          }
        );
      }
    }
    // this.mountRef.current.style.display = 'none';
  };
  secondReduce = (y) => {
    console.log(this.footType);
    if (
      this.state.footType === "seconds" ||
      (["HH:mm:ss", "yyyy-MM-dd HH:mm:ss"].indexOf(this.options.format) > -1 &&
        this.state.footType == "")
    ) {
      let seconds = this.state.seconds;
      if (seconds == 0) {
        seconds = 59;
      } else {
        seconds--;
      }

      this.setState({
        seconds: seconds,
        footType: "seconds",
      });
      return;
    }
    if (
      this.state.footType == "minutes" ||
      (["HH:mm", "yyyy-MM-dd HH:mm"].indexOf(this.options.format) > -1 &&
        this.state.footType == "")
    ) {
      let minutes = this.state.minutes;
      if (minutes == 0) {
        minutes = 59;
      } else {
        minutes--;
      }

      this.setState({
        minutes: minutes,
        footType: "minutes",
      });
      return;
    }
    if (this.state.footType == "hours") {
      let hours = this.state.hours;
      if (hours == 0) {
        hours = 23;
      } else {
        hours--;
      }

      this.setState({
        hours: hours,
      });
      return;
    }
  };

  secondAdd = (y) => {
    if (
      this.state.footType === "seconds" ||
      (["HH:mm:ss", "yyyy-MM-dd HH:mm:ss"].indexOf(this.options.format) > -1 &&
        this.state.footType == "")
    ) {
      let seconds = this.state.seconds;
      if (seconds == 59) {
        seconds = 0;
      } else {
        seconds++;
      }

      this.setState({
        seconds: seconds,
        footType: "seconds",
      });
      return;
    }
    if (
      this.state.footType == "minutes" ||
      (["HH:mm", "yyyy-MM-dd HH:mm"].indexOf(this.options.format) > -1 &&
        this.state.footType == "")
    ) {
      let minutes = this.state.minutes;
      if (minutes == 59) {
        minutes = 0;
      } else {
        minutes++;
      }

      this.setState({
        minutes: minutes,
        footType: "minutes",
      });
      return;
    }
    if (this.state.footType == "hours") {
      let hours = this.state.hours;
      if (hours == 23) {
        hours = 0;
      } else {
        hours++;
      }

      this.setState({
        hours: hours,
      });
      return;
    }
  };

  changeDay = (day, month, year, valid) => {
    return (event) => {
      const { format } = this.options;
      if (valid === "oday") {
        return;
      }
      this.setState(
        {
          year: year,
          month: month,
          day: day,
        },
        () => {
          if (format.indexOf("HH") == -1) {
            this.onDateUpdate(true);
          } else {
            this.onDateUpdate();
          }
        }
      );
    };
  };

  clearDay = () => {
    return (event) => {
      if (this.props.onDateClear) {
        this.props.onDateClear();
      }
    };
  };

  toDay = () => {
    return (event) => {
      let tdt = dayjsUtils.timeToTZ(new Date());
      tdt = BsyUtils.getFormatDate(tdt, this.options.format);  
      this.setState(
        {
          year: tdt.getFullYear(),
          month: tdt.getMonth(),
          day: tdt.getDate(),
          hours: tdt.getHours(),
          minutes: tdt.getMinutes(),
          seconds: tdt.getSeconds(),
        },
        () => {
          this.renderScrollTo();
          this.onDateUpdate(true);
        }
      );
    };
  };

  OkDay = () => {
    return (event) => {
      this.onDateUpdate(true);
    };
  };

  onDateUpdate = (closeFloat) => {
    if (this.props.onDateUpdate) {
      if (
        this.checkValidate(
          new Date(
            this.state.year,
            this.state.month,
            this.state.day,
            this.state.hours,
            this.state.minutes,
            this.state.seconds
          )
        )
      ) {
        this.props.onDateUpdate(
          new Date(
            this.state.year,
            this.state.month,
            this.state.day,
            this.state.hours,
            this.state.minutes,
            this.state.seconds
          ),
          closeFloat
        );
      } else {
        this.props.onDateUpdate(null, closeFloat);
      }
    }
  };

  //验证日期范围
  checkValidate = (ddt) => {
    if (this.startDate && this.endDate) {
      if (ddt >= this.startDate && ddt <= this.endDate) {
        return true;
      }
    }
    return false;
  };

  onMonthMenu = () => {
    this.setState({
      showMonth: true,
      showYear: false,
      showHms: false,
    });
  };

  onYearhMenu = () => {
    this.setState({
      showYear: true,
      showHms: false,
    });
  };

  onClick = (type, val) => {
    // hours, minutes, seconds
    this.setState({ [type]: val }, () => {
      this.renderScrollTo();
      this.onDateUpdate();
    });
  };

  selectItem = (item, type) => {
    const { value } = this.state;
    let val = null;
    if (value && value[type]) {
      val = value[type];
    }
    if (!val) {
      return "";
    }
    if (item.text == val) {
      return "selected";
    }
    return "";
  };

  renderScrollTo = () => {
    this.scrollTop = this.scrollTop || {};
    let itmeheight = 32;
    if (BsyUtils.isTrue(this.scrollTop.hours)) {
      let res = this.element.current.querySelector(".hours .col-list");
      if (res) {
        res.scrollTop = this.scrollTop.hours * itmeheight;
      }
    }
    if (BsyUtils.isTrue(this.scrollTop.minutes)) {
      let res = this.element.current.querySelector(".minutes .col-list");
      if (res) {
        res.scrollTop = this.scrollTop.minutes * itmeheight;
      }
    }
    if (BsyUtils.isTrue(this.scrollTop.seconds)) {
      let res = this.element.current.querySelector(".seconds .col-list");
      if (res) {
        res.scrollTop = this.scrollTop.seconds * itmeheight;
      }
    }

    var ret = BsyUtils.closestClass(this.element.current, "bsy-msg-bubble");
    if (ret) {
      let offset = BsyUtils.elemoffset(ret);
      let width = ret.offsetWidth;
      if (width + offset.left > document.body.clientWidth) {
        ret.style.left = "auto";
        ret.style.right = 0;
      }
    }
  };

  renderTimeList = (type) => {
    let colleng = 24;
    if (type === "minutes" || type == "seconds") {
      colleng = 60;
    }

    let tmap = {
      hours: React.language("hour"),
      minutes: React.language("minute"),
      seconds: React.language("second"),
    };
    // hours, minutes, seconds

    this.scrollTop = this.scrollTop || {};
    this.scrollTop[type] = 0;

    let colRange = new Array(colleng);
    colRange.fill(null);
    return (
      <div className={"col " + type}>
        <div className="label">{tmap[type]}</div>
        <div className="col-list">
          {colRange.map((item, index) => {
            let select = this.state[type] == index;
            if (select) {
              this.scrollTop[type] = index;
            }
            let val = index;
            return (
              <div
                className={"col-item " + (select ? "select" : "")}
                onClick={() => {
                  this.onClick(type, val);
                }}
              >
                {index > 9 ? index : "0" + index}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  hoursHandleChange(event) {
    this.setState(
      { hours: event.target.value > 23 ? 23 : event.target.value },
      () => {
        this.renderScrollTo();
        this.onDateUpdate();
      }
    );
  }

  minutesHandleChange(event) {
    this.setState(
      { minutes: event.target.value > 59 ? 59 : event.target.value },
      () => {
        this.renderScrollTo();
        this.onDateUpdate();
      }
    );
  }

  secondsHandleChange(event) {
    this.setState(
      { seconds: event.target.value > 59 ? 59 : event.target.value },
      () => {
        this.renderScrollTo();
        this.onDateUpdate();
      }
    );
  }

  render() {
    const {
      year,
      month,
      day,
      hours,
      minutes,
      seconds,
      showMonth,
      showYear,
      showHms,
    } = this.state;
    const { cssName, format, hasTfoot } = this.options;
    let that = this;

    const date = new Date(year, month, day);

    const today = new Date();
    date.setDate(1);
    date.setDate(0 - (7 & date.getDay()));
    date.setDate(date.getDate() + 1);

    // if ('yyyy' === format) {
    this.startYear = year - 9;
    this.endYear = year + 10;
    // }

    return (
      <div
        className={cssName}
        ref={this.element}
        style={{
          position: "relative",
        }}
      >
        <div style={{ display: "flex" }}>
          <>
            {format.indexOf("yyyy") > -1 ? (
              <div className="data-range">
                {[
                  "HH:mm:ss",
                  "HH:mm",
                  "yyyy-MM-dd HH:mm:ss",
                  "yyyy-MM-dd HH:mm",
                  "yyyy-MM-dd",
                ].indexOf(format) > -1 && (
                    <table
                      cellSpacing="2px"
                      cellPadding="0"
                      className="dt"
                      style={{
                        width: "100%",
                      }}
                    >
                      {[
                        "yyyy-MM-dd HH:mm:ss",
                        "yyyy-MM-dd HH:mm",
                        "yyyy-MM-dd",
                      ].indexOf(format) > -1 && (
                          <>
                            <thead>
                              <tr className="mainhead">
                                <td
                                  className="btn prevm"
                                  colSpan="1"
                                  onClick={this.yearReduce}
                                >
                                  <i className="icon-double-left"></i>
                                </td>
                                <td
                                  className="btn prevm"
                                  colSpan="1"
                                  onClick={this.monthReduce}
                                >
                                  <i className="icon-bsy-left"></i>
                                </td>
                                <td className="title" colSpan="3">
                                  <span
                                    className="title-month"
                                    onClick={this.onMonthMenu}
                                  >
                                    {this.MN[month]}
                                  </span>
                                  ,
                                  <span
                                    onClick={this.onYearhMenu}
                                    className="title-year"
                                  >
                                    {year}
                                  </span>
                                </td>
                                <td
                                  className="btn nextm"
                                  colSpan="1"
                                  onClick={this.monthAdd}
                                >
                                  <i className="icon-bsy-right"></i>
                                </td>
                                <td
                                  className="btn nextm"
                                  colSpan="1"
                                  onClick={this.yearAdd}
                                >
                                  <i className="icon-double-right"></i>
                                </td>
                              </tr>
                              <tr>
                                <td className="day name weekend week">
                                  {this.SDN[0]}
                                </td>
                                <td className="day name week">{this.SDN[1]}</td>
                                <td className="day name week">{this.SDN[2]}</td>
                                <td className="day name week">{this.SDN[3]}</td>
                                <td className="day name week">{this.SDN[4]}</td>
                                <td className="day name week">{this.SDN[5]}</td>
                                <td className="day name weekend week">
                                  {this.SDN[6]}
                                </td>
                              </tr>
                            </thead>

                            <tbody>
                              {this.trNum.map((res) => {
                                return (
                                  <tr>
                                    {this.weekArray.map((res, key) => {
                                      let y = date.getDate();

                                      let day1 = date.getDate();
                                      let mon1 = date.getMonth();
                                      let year1 = date.getFullYear();

                                      let lcss = "oday";

                                      if (
                                        this.checkValidate(
                                          new Date(
                                            year1,
                                            mon1,
                                            day1,
                                            today.getHours(),
                                            today.getMinutes(),
                                            today.getSeconds(),
                                            today.getMilliseconds()
                                          )
                                        )
                                      ) {
                                        if (month !== mon1) {
                                          lcss = "oday";
                                        } else {
                                          lcss = "day";
                                          if (key == 0 || key == 6) {
                                            lcss += " weekend";
                                          }
                                          if (
                                            today.getDate() === y &&
                                            mon1 === today.getMonth() &&
                                            year1 === today.getFullYear()
                                          ) {
                                            lcss += " today";
                                          }
                                          if (day === y && month === mon1) {
                                            lcss += " selected";
                                          }
                                        }
                                      }

                                      date.setDate(y + 1);
                                      return (
                                        <td
                                          onClick={this.changeDay(
                                            day1,
                                            mon1,
                                            year1,
                                            lcss
                                          )}
                                          key={
                                            "d" + year1 + "-" + mon1 + "-" + day1
                                          }
                                          className={lcss}
                                        >
                                          <div className="day-wrapper">
                                            <div className="day-item">{y}</div>
                                          </div>
                                        </td>
                                      );
                                    })}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </>
                        )}
                    </table>
                  )}
                {["yyyy-MM-dd HH:mm:ss", "yyyy-MM-dd", "yyyy-MM"].indexOf(
                  format
                ) > -1 && (
                    <>
                      <table
                        cellSpacing="2px"
                        cellPadding="0"
                        className="mt"
                        ref={this.mountRef}
                        style={{
                          display:
                            format === "yyyy-MM"
                              ? showYear
                                ? "none"
                                : ""
                              : showMonth
                                ? showYear
                                  ? "none"
                                  : ""
                                : "none",
                          position:
                            format === "yyyy-MM" ? "relative" : "absolute",
                          top: 0,
                          bottom: 0,
                          right: 0,
                          zIndex: 1,
                          left: 0,
                          height: "100%",
                          width: "100%",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td
                              className="btn prevy"
                              colSpan="1"
                              onClick={() => {
                                this.yearReduce();
                              }}
                            >
                              <i className="icon-angleleft"></i>
                            </td>
                            <td
                              className="year title"
                              colSpan="1"
                              onClick={this.onYearhMenu}
                            >
                              {year}
                            </td>
                            <td
                              className="btn nexty"
                              colSpan="1"
                              onClick={() => {
                                this.yearAdd();
                              }}
                            >
                              <i className="icon-angleright"></i>
                            </td>
                          </tr>

                          <tr>
                            <td
                              className={
                                "month " + (month === 0 ? "selected" : "")
                              }
                              onClick={(e) => {
                                this.mountOk(0);
                              }}
                            >
                              {this.MN[0]}
                            </td>
                            <td
                              className={
                                "month " + (month === 1 ? "selected" : "")
                              }
                              onClick={(e) => {
                                this.mountOk(1);
                              }}
                            >
                              {this.MN[1]}
                            </td>
                            <td
                              className={
                                "month " + (month === 2 ? "selected" : "")
                              }
                              onClick={(e) => {
                                this.mountOk(2);
                              }}
                            >
                              {this.MN[2]}
                            </td>
                          </tr>
                          <tr>
                            <td
                              className={
                                "month " + (month === 3 ? "selected" : "")
                              }
                              onClick={(e) => {
                                this.mountOk(3);
                              }}
                            >
                              {this.MN[3]}
                            </td>
                            <td
                              className={
                                "month " + (month === 4 ? "selected" : "")
                              }
                              onClick={(e) => {
                                this.mountOk(4);
                              }}
                            >
                              {this.MN[4]}
                            </td>
                            <td
                              className={
                                "month " + (month === 5 ? "selected" : "")
                              }
                              onClick={(e) => {
                                this.mountOk(5);
                              }}
                            >
                              {this.MN[5]}
                            </td>
                          </tr>
                          <tr>
                            <td
                              className={
                                "month " + (month === 6 ? "selected" : "")
                              }
                              onClick={(e) => {
                                this.mountOk(6);
                              }}
                            >
                              {this.MN[6]}
                            </td>
                            <td
                              className={
                                "month " + (month === 7 ? "selected" : "")
                              }
                              onClick={(e) => {
                                this.mountOk(7);
                              }}
                            >
                              {this.MN[7]}
                            </td>
                            <td
                              className={
                                "month " + (month === 8 ? "selected" : "")
                              }
                              onClick={(e) => {
                                this.mountOk(8);
                              }}
                            >
                              {this.MN[8]}
                            </td>
                          </tr>
                          <tr>
                            <td
                              className={
                                "month " + (month === 9 ? "selected" : "")
                              }
                              onClick={(e) => {
                                this.mountOk(9);
                              }}
                            >
                              {this.MN[9]}
                            </td>
                            <td
                              className={
                                "month " + (month === 10 ? "selected" : "")
                              }
                              onClick={(e) => {
                                this.mountOk(10);
                              }}
                            >
                              {this.MN[10]}
                            </td>
                            <td
                              className={
                                "month " + (month === 11 ? "selected" : "")
                              }
                              onClick={(e) => {
                                this.mountOk(11);
                              }}
                            >
                              {this.MN[11]}
                            </td>
                          </tr>
                          {/* <tr>
                                                    <td className="btn prevy" colSpan="1" onClick={(e) => { this.yearReduce() }} ><i className="icon-angleleft"></i></td>
                                                    <td className="btn nexty" colSpan="1" onClick={(e) => { this.yearAdd() }} ><i className="icon-angleright"></i></td>
                                                    <td className={"month " + (month === 0 ? 'selected' : '')} onClick={(e) => { this.mountOk(0) }} >{this.MN[0]}</td>
                                                    <td className={"month " + (month === 1 ? 'selected' : '')} onClick={(e) => { this.mountOk(1) }} >{this.MN[1]}</td>

                                                </tr>
                                                <tr>
                                                    <td className="year" onClick={(e) => { this.yearOk(year - 4) }} >{year - 4}</td>
                                                    <td className="year" onClick={(e) => { this.yearOk(year - 3) }} >{year - 3}</td>
                                                    <td className={"month " + (month === 2 ? 'selected' : '')} onClick={(e) => { this.mountOk(2) }} >{this.MN[2]}</td>
                                                    <td className={"month " + (month === 3 ? 'selected' : '')} onClick={(e) => { this.mountOk(3) }} >{this.MN[3]}</td>

                                                </tr>
                                                <tr>
                                                    <td className="year" onClick={(e) => { this.yearOk(year - 2) }} >{year - 2}</td>
                                                    <td className="year" onClick={(e) => { this.yearOk(year - 1) }} >{year - 1}</td>
                                                    <td className={"month " + (month === 4 ? 'selected' : '')} onClick={(e) => { this.mountOk(4) }} >{this.MN[4]}</td>
                                                    <td className={"month " + (month === 5 ? 'selected' : '')} onClick={(e) => { this.mountOk(5) }} >{this.MN[5]}</td>

                                                </tr>
                                                <tr>
                                                    <td className="year selected" onClick={(e) => { this.yearOk(year) }} >{year}</td>
                                                    <td className="year" onClick={(e) => { this.yearOk(year + 1) }} >{year + 1}</td>
                                                    <td className={"month " + (month === 6 ? 'selected' : '')} onClick={(e) => { this.mountOk(6) }} >{this.MN[6]}</td>
                                                    <td className={"month " + (month === 7 ? 'selected' : '')} onClick={(e) => { this.mountOk(7) }} >{this.MN[7]}</td>

                                                </tr>
                                                <tr>
                                                    <td className="year" onClick={(e) => { this.yearOk(year + 2) }} >{year + 2}</td>
                                                    <td className="year" onClick={(e) => { this.yearOk(year + 3) }} >{year + 3}</td>
                                                    <td className={"month " + (month === 8 ? 'selected' : '')} onClick={(e) => { this.mountOk(8) }} >{this.MN[8]}</td>
                                                    <td className={"month " + (month === 9 ? 'selected' : '')} onClick={(e) => { this.mountOk(9) }} >{this.MN[9]}</td>

                                                </tr>
                                                <tr>
                                                    <td className="year" onClick={(e) => { this.yearOk(year + 4) }} >{year + 4}</td>
                                                    <td className="year" onClick={(e) => { this.yearOk(year + 5) }} >{year + 5}</td>
                                                    <td className={"month " + (month === 10 ? 'selected' : '')} onClick={(e) => { this.mountOk(10) }} >{this.MN[10]}</td>
                                                    <td className={"month " + (month === 11 ? 'selected' : '')} onClick={(e) => { this.mountOk(11) }} >{this.MN[11]}</td>

                                                </tr> */}
                        </tbody>
                      </table>
                      <table
                        cellSpacing="2px"
                        cellPadding="0"
                        className="mt"
                        style={{
                          display: showYear ? "" : "none",
                          position:
                            format === "yyyy-MM" ? "relative" : "absolute",
                          top: 0,
                          bottom: 0,
                          right: 0,
                          zIndex: 1,
                          left: 0,
                          height: "100%",
                          width: "100%",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td
                              className="btn prevy"
                              colSpan="1"
                              onClick={() => {
                                this.yearFReduce();
                              }}
                            >
                              <i className="icon-angleleft"></i>
                            </td>
                            <td className="year title" colSpan="2">
                              {this.startYear + " - " + this.endYear}
                            </td>
                            <td
                              className="btn nexty"
                              colSpan="1"
                              onClick={() => {
                                this.yearFAdd();
                              }}
                            >
                              <i className="icon-angleright"></i>
                            </td>
                          </tr>
                          {this.trYearNum.map((res, index) => {
                            let dd = this.startYear + index * 4;
                            return (
                              <tr>
                                <td
                                  className={
                                    "year " + (year === dd ? "selected" : "")
                                  }
                                  onClick={() => {
                                    this.selectYear(dd);
                                  }}
                                >
                                  {dd}
                                </td>
                                <td
                                  className={
                                    "year " + (year === dd + 1 ? "selected" : "")
                                  }
                                  onClick={() => {
                                    this.selectYear(dd + 1);
                                  }}
                                >
                                  {dd + 1}
                                </td>
                                <td
                                  className={
                                    "year " + (year === dd + 2 ? "selected" : "")
                                  }
                                  onClick={() => {
                                    this.selectYear(dd + 2);
                                  }}
                                >
                                  {dd + 2}
                                </td>
                                <td
                                  className={
                                    "year " + (year === dd + 3 ? "selected" : "")
                                  }
                                  onClick={() => {
                                    this.selectYear(dd + 3);
                                  }}
                                >
                                  {dd + 3}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </>
                  )}
                {"yyyy" === format && (
                  <table
                    cellSpacing="2px"
                    cellPadding="0"
                    className="mt"
                    style={{
                      width: "100%",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          className="btn prevy"
                          colSpan="1"
                          onClick={() => {
                            this.yearFReduce();
                          }}
                        >
                          <i className="icon-angleleft"></i>
                        </td>
                        <td className="year title" colSpan="2">
                          {this.startYear +
                            React.language("year") +
                            " - " +
                            this.endYear +
                            React.language("year")}
                        </td>
                        <td
                          className="btn nexty"
                          colSpan="1"
                          onClick={() => {
                            this.yearFAdd();
                          }}
                        >
                          <i className="icon-angleright"></i>
                        </td>
                      </tr>
                      {this.trYearNum.map((res, index) => {
                        let dd = this.startYear + index * 4;
                        return (
                          <tr>
                            <td
                              className={
                                "year " + (year === dd ? "selected" : "")
                              }
                              onClick={() => {
                                this.selectYear(dd);
                              }}
                            >
                              {dd}
                            </td>
                            <td
                              className={
                                "year " + (year === dd + 1 ? "selected" : "")
                              }
                              onClick={() => {
                                this.selectYear(dd + 1);
                              }}
                            >
                              {dd + 1}
                            </td>
                            <td
                              className={
                                "year " + (year === dd + 2 ? "selected" : "")
                              }
                              onClick={() => {
                                this.selectYear(dd + 2);
                              }}
                            >
                              {dd + 2}
                            </td>
                            <td
                              className={
                                "year " + (year === dd + 3 ? "selected" : "")
                              }
                              onClick={() => {
                                this.selectYear(dd + 3);
                              }}
                            >
                              {dd + 3}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            ) : (
              ""
            )}
          </>

          <>
            {showHms && format.indexOf("HH") > -1 ? (
              <div className="time-range">
                <div className="time-input">
                  <input
                    type="number"
                    defaultValue={hours}
                    value={hours}
                    onChange={this.hoursHandleChange}
                    onBlur={(event) => {
                      let val = event.target.value;
                      if (val > 23) {
                        val = 23;
                      }
                      that.setTimeHandle && clearTimeout(that.setTimeHandle);
                      that.setTimeHandle = setTimeout(() => {
                        that.onClick("hours", val);
                      }, 500);
                    }}
                  ></input>

                  {format.indexOf("mm") > -1 ? (
                    <>
                      <span>:</span>
                      <input
                        type="number"
                        defaultValue={minutes}
                        value={minutes}
                        onChange={this.minutesHandleChange}
                        onBlur={(event) => {
                          let val = event.target.value;
                          if (val > 59) {
                            val = 59;
                          }
                          that.setTimeHandle &&
                            clearTimeout(that.setTimeHandle);
                          that.setTimeHandle = setTimeout(() => {
                            that.onClick("minutes", val);
                          }, 500);
                        }}
                      ></input>
                    </>
                  ) : (
                    ""
                  )}

                  {format.indexOf("ss") > -1 ? (
                    <>
                      <span>:</span>

                      <input
                        type="number"
                        defaultValue={seconds}
                        value={seconds}
                        onChange={this.secondsHandleChange}
                        onBlur={(event) => {
                          let val = event.target.value;
                          if (val > 59) {
                            val = 59;
                          }
                          that.setTimeHandle &&
                            clearTimeout(that.setTimeHandle);
                          that.setTimeHandle = setTimeout(() => {
                            that.onClick("seconds", val);
                          }, 500);
                        }}
                      ></input>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className="time-select-range">
                  {format.indexOf("HH") > -1
                    ? this.renderTimeList("hours")
                    : ""}
                  {format.indexOf("mm") > -1
                    ? this.renderTimeList("minutes")
                    : ""}
                  {
                    format.indexOf("ss") > -1
                      ? this.renderTimeList("seconds")
                      : "" //hours, minutes, seconds
                  }
                </div>
              </div>
            ) : (
              ""
            )}
          </>
        </div>

        {format.indexOf("HH:") > -1 ? (
          <div className="footer">
            <div className="hms">
              <div className="btn current-time" onClick={this.toDay()}>
                {React.language("current.time")}
              </div>
              <div className="btn ok" onClick={this.OkDay()}>
                {React.language("ok")}
              </div>
              <div className="btn" onClick={this.clearDay()}>
                {React.language("clear")}
              </div>
            </div>
          </div>
        ) : format.indexOf("-dd") > -1 ? (
          <div className="footer">
            <div className="hms">
              <div className="btn today" onClick={this.toDay()}>
                {React.language("today")}
              </div>
              <div className="btn" onClick={this.clearDay()}>
                {React.language("clear")}
              </div>
            </div>
          </div>
        ) : (
          <div className="footer">
            <div className="hms">
              <div className="btn today" onClick={this.toDay()}>
                {React.language("current.time")}
              </div>
              <div className="btn" onClick={this.clearDay()}>
                {React.language("clear")}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
